module.exports = __webpack_public_path__ + "static/media/background.526e9b47.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/background.png
// module id = 24
// module chunks = 0